module.exports = __webpack_public_path__ + "img/Icon_mailopen.f1466ff8.svg";